import { t } from 'i18next';

import Subchapter from '@/models/Subchapter';
import { mapTypeToRoute } from '@/utils/book/bookAdapters';
import requester from '@/lib/axios';
import { ChapterParams } from './chapterServices';

export type SubchapterParams = ChapterParams & {
  subchapterId: number;
};

type CreateSubchapter = Omit<Subchapter, 'id' | 'order'>;

export const subchapterPath = 'items';

export async function createSubchapter(
  params: ChapterParams,
  body?: CreateSubchapter,
) {
  const { lessonId, bookType, bookId, chapterId } = params;

  const endpoint = mapTypeToRoute[bookType];

  const complementedBody = {
    title: t('subchapter.title'),
    ...body,
  };

  const { data: chapter } = await requester().post<Subchapter>(
    `lessons/${lessonId}/${endpoint}/${bookId}/chapters/${chapterId}/${subchapterPath}/`,
    complementedBody,
  );

  return chapter;
}

export type UpdateSubchaptersOrder = {
  params: ChapterParams;
  subchapters: { id: number }[];
};

export async function updateSubchaptersOrder({
  params,
  subchapters,
}: UpdateSubchaptersOrder) {
  const { lessonId, bookType, bookId, chapterId } = params;

  const endpoint = mapTypeToRoute[bookType];

  await requester().patch(
    `lessons/${lessonId}/${endpoint}/${bookId}/chapters/${chapterId}/${subchapterPath}/order/`,
    subchapters,
  );
}

export async function updateSubchapter(
  params: SubchapterParams,
  body?: Partial<Subchapter>,
) {
  const { lessonId, bookType, bookId, chapterId, subchapterId } = params;

  const endpoint = mapTypeToRoute[bookType];

  const { data } = await requester().patch<Subchapter>(
    `lessons/${lessonId}/${endpoint}/${bookId}/chapters/${chapterId}/${subchapterPath}/${subchapterId}/`,
    body,
  );

  return data;
}

export async function deleteSubchapter(params: SubchapterParams) {
  const { lessonId, bookType, bookId, chapterId, subchapterId } = params;

  const endpoint = mapTypeToRoute[bookType];

  await requester().delete<void>(
    `lessons/${lessonId}/${endpoint}/${bookId}/chapters/${chapterId}/${subchapterPath}/${subchapterId}/`,
  );
}
